import { render, staticRenderFns } from "./tip-add.vue?vue&type=template&id=2917b868&scoped=true&"
import script from "./tip-add.vue?vue&type=script&lang=js&"
export * from "./tip-add.vue?vue&type=script&lang=js&"
import style0 from "./tip-add.vue?vue&type=style&index=0&id=2917b868&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2917b868",
  null
  
)

export default component.exports